module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"yAxisTitle":{"ee":"Endenergieverbrauch in","s12e":"Scope 1-2 Emissionen in"},"tooltipTitle":{"ee":"Endenergie","s12e":"Emissionen"},"valueTypeUnit":{"ee":{"absolute":"MWh","specific":"kWh/m²"},"s12e":{"absolute":"t CO₂e","specific":"kg CO₂e/m²"}}}}')
  delete Component.options._Ctor
}
